import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import Divider from "../../../components/Divider";
import TwoSectionsImages from "../../../components/TwoSectionsImages";
import TwoSections from "../../../components/TwoSections";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const GifPlayer = makeShortcode("GifPlayer");
const Video = makeShortcode("Video");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <PageDescription mdxType="PageDescription">
      <p>{`As a critical moment within the workplace journey, the Welcome zone is often the first impression a client or guest may experience upon entry. A warm sense of hospitality is essential to both the design and operation of the environment. The reference images and guidance below are a kit of parts designed to meet a variety of project needs—yet maintain a cohesive experience for our guests.`}</p>
    </PageDescription>
    <Row mdxType="Row">
      <Column mdxType="Column">
        <GifPlayer className="video-player" mdxType="GifPlayer">
          <Video autoPlay playsInline loop="on" muted src="/workplace-xg/4d802be98726eca6d007c11593cde5b3/welcome.mp4" mdxType="Video" />
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAgQA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAbAXDbptR//EABsQAAICAwEAAAAAAAAAAAAAAAECAyIAETIS/9oACAEBAAEFAoeWCti68gVk5hNP/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAEEH/2gAIAQIBAT8Bh//EABkQAAMAAwAAAAAAAAAAAAAAAAAQEQExgf/aAAgBAQAGPwIpiaXF/8QAHRAAAgICAwEAAAAAAAAAAAAAAAERITFhQVFxgf/aAAgBAQABPyGCi+zJ70M7+Chf3sW0VCY9GO7bt5P/2gAMAwEAAgADAAAAECzf/8QAFhEBAQEAAAAAAAAAAAAAAAAAAAEx/9oACAEDAQE/EJqv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAECAQE/EGDt/8QAGxABAQEAAgMAAAAAAAAAAAAAAREAITFBcYH/2gAIAQEAAT8QbYHLk9a/ZBOV+pjRRGEjNCIzsVgEShCkemD3Qqqyvl3/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "animation of three welcome zones of various size",
              "title": "animation of three welcome zones of various size",
              "src": "/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/2e753/welcome-zone-with-reception-desk-and-seating.jpg",
              "srcSet": ["/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/69549/welcome-zone-with-reception-desk-and-seating.jpg 288w", "/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/473e3/welcome-zone-with-reception-desk-and-seating.jpg 576w", "/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/2e753/welcome-zone-with-reception-desk-and-seating.jpg 1152w", "/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/74f4b/welcome-zone-with-reception-desk-and-seating.jpg 1728w", "/workplace-xg/static/b239f0009f2a5352539dcef1ef56a65b/f35b7/welcome-zone-with-reception-desk-and-seating.jpg 1856w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </GifPlayer>
      </Column>
    </Row>
    <h2>{`Signature moments`}</h2>
    <p>{`IBM environments are defined by signature elements that may be adapted in their execution to meet a project’s specific needs, regardless of a project’s size or budget. The examples shown here illustrate a variety of Welcome zones, each with a different footprint, but unified through a thoughtful approach to brand expression, pattern and interior design. Beyond the presence of our logo, these elements make our environments connected and identifiable.`}</p>
    <Divider mdxType="Divider" />
    <TwoSections title="Finish palette" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
    
  The use of wood within the Welcome zone reinforces a warm sense of hospitality. Juxtaposed with other neutral finishes, such as concrete, stone, glass or metal, wood serves as a consistent baseline throughout our environments. Wood can be locally sourced but should be uniform in tone and grain as seen here. Combined with a custom millwork pattern, wood becomes a signature element in our Welcome zone. This combination can be executed in varying degrees of coverage in wall, ceiling and flooring treatments.
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgUD/8QAFwEBAQEBAAAAAAAAAAAAAAAAAgADBP/aAAwDAQACEAMQAAAB1o88BWpDPalK5w7sP//EABsQAAICAwEAAAAAAAAAAAAAAAACAQMQETIS/9oACAEBAAEFAirk8HJucTWsvYzLZ//EABcRAQADAAAAAAAAAAAAAAAAAAEAEBH/2gAIAQMBAT8BbV2f/8QAGREAAgMBAAAAAAAAAAAAAAAAAQIAEBIh/9oACAECAQE/ARaquRyf/8QAGRABAAMBAQAAAAAAAAAAAAAAAQAQEQJB/9oACAEBAAY/Ar9mbas6Bcn/xAAcEAACAgIDAAAAAAAAAAAAAAAAAREhUWEQMZH/2gAIAQEAAT8hqTDkkU+0E7LDRtfnCkrFNyOkf//aAAwDAQACAAMAAAAQ8Mg+/8QAGBEAAgMAAAAAAAAAAAAAAAAAABEQITH/2gAIAQMBAT8QyKHFn//EABkRAQACAwAAAAAAAAAAAAAAAAEAMRARUf/aAAgBAgEBPxC83hyIrk//xAAeEAEAAgIBBQAAAAAAAAAAAAABABEhMUFRYXGBof/aAAgBAQABPxDZfWDC2BZlHaX3gBbPhjtIDtV/YNpvScXG0rHNvASk2sHWCf/Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "welcome zone finish palette",
            "title": "welcome zone finish palette",
            "src": "/workplace-xg/static/47ce69e0de73acf3573f0c088268da1a/2e753/welcome-zone-finish-palette.jpg",
            "srcSet": ["/workplace-xg/static/47ce69e0de73acf3573f0c088268da1a/69549/welcome-zone-finish-palette.jpg 288w", "/workplace-xg/static/47ce69e0de73acf3573f0c088268da1a/473e3/welcome-zone-finish-palette.jpg 576w", "/workplace-xg/static/47ce69e0de73acf3573f0c088268da1a/2e753/welcome-zone-finish-palette.jpg 1152w", "/workplace-xg/static/47ce69e0de73acf3573f0c088268da1a/efa0b/welcome-zone-finish-palette.jpg 1214w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Color strategy" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Our color strategy for environments is based on specific space types. As a first impression for guests, Welcome zones should feature a dynamic application of blue. In these instances, blue should be applied with purpose as a focal element and architectural finish, such as glass, metal or ceramic brick. These materials serve to elevate blue as a vibrant, distinct component to our identity and our environments. Avoid generic painted surfaces or decorative applications in furniture and textiles within the Welcome zone. Learn more about our `}<a parentName="p" {...{
            "href": "/workplace-xg/interior-architecture/color"
          }}>{`color strategy for environments`}</a>{`.`}</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "151.04166666666669%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQP/2gAMAwEAAhADEAAAAaIm741AQ5JXyNBRT//EABsQAQEAAgMBAAAAAAAAAAAAAAECAxIAESIh/9oACAEBAAEFAhIJKyuTH6odnIaGLcadljk576Tvknyz1//EABkRAAIDAQAAAAAAAAAAAAAAAAABEiExQf/aAAgBAwEBPwGXB6JWM//EABoRAAIDAQEAAAAAAAAAAAAAAAABAhFBEiH/2gAIAQIBAT8B43RS8G7Qoqj/xAAhEAABAgQHAAAAAAAAAAAAAAAAAQIQESExEhMiI0GBkf/aAAgBAQAGPwLG7pCalibjbdyI7McIjrGlJV9jWH//xAAdEAACAgIDAQAAAAAAAAAAAAABEQAhMVEQYaHh/9oACAEBAAE/Ifs0hpjcIKVWoQ8x4IopOa0oQ5YIiNM9wIAPZA1AqggAa4w2RxdNT//aAAwDAQACAAMAAAAQaPN//8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERMSH/2gAIAQMBAT8QXUYhaxIaP//EABkRAQEAAwEAAAAAAAAAAAAAAAEAESExof/aAAgBAgEBPxDnLryIBmPTMDf/xAAdEAEBAAIDAAMAAAAAAAAAAAABEQAhMUFRocHx/9oACAEBAAE/EO+3HcvcZ+DQ8J1gALRzVwzIR8CcBhiVxWr+mUMzu794LwkKxMaeKSICSU3gjTAAB8YtCjOLjAAKI9mHKEh3n//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "welcome zone color strategy",
              "title": "welcome zone color strategy",
              "src": "/workplace-xg/static/41c9b9f841af0043210ed3ebf663e837/473e3/welcome-zone-color-strategy.jpg",
              "srcSet": ["/workplace-xg/static/41c9b9f841af0043210ed3ebf663e837/69549/welcome-zone-color-strategy.jpg 288w", "/workplace-xg/static/41c9b9f841af0043210ed3ebf663e837/473e3/welcome-zone-color-strategy.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAIBAwT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB9lcdS0l0AH//xAAbEAABBAMAAAAAAAAAAAAAAAABAAIQERIgIf/aAAgBAQABBQIdOJgoPcFd6f/EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8BH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EABgQAAIDAAAAAAAAAAAAAAAAAAAxEBEg/9oACAEBAAY/AqFLz//EABwQAQACAgMBAAAAAAAAAAAAAAERMQAhECChsf/aAAgBAQABPyEaCTcLiNrgMyXmgp7k9vvT/9oADAMBAAIAAwAAABCcCDz/xAAUEQEAAAAAAAAAAAAAAAAAAAAg/9oACAEDAQE/EB//xAAVEQEBAAAAAAAAAAAAAAAAAAAgIf/aAAgBAgEBPxCD/8QAHhABAAICAQUAAAAAAAAAAAAAAQARECFRMWGBkaH/2gAIAQEAAT8QJgydAUhN0OTZhRagUI0nmP27ilD1p+RW7l8N4olT/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "welcome zone reception desk color strategy",
              "title": "welcome zone reception desk color strategy",
              "src": "/workplace-xg/static/1036d83f3d478b95003cf3e606914c8e/473e3/welcome-zone-reception-desk-color-strategy.jpg",
              "srcSet": ["/workplace-xg/static/1036d83f3d478b95003cf3e606914c8e/69549/welcome-zone-reception-desk-color-strategy.jpg 288w", "/workplace-xg/static/1036d83f3d478b95003cf3e606914c8e/473e3/welcome-zone-reception-desk-color-strategy.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIEBQb/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABZ5rmZLUj/8QAGRAAAwEBAQAAAAAAAAAAAAAAAQISACEx/9oACAEBAAEFAqhSqlO4Y+MBX//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABURAQEAAAAAAAAAAAAAAAAAABBB/9oACAECAQE/AYf/xAAXEAADAQAAAAAAAAAAAAAAAAAAETEg/9oACAEBAAY/AoPEP//EABsQAQACAgMAAAAAAAAAAAAAAAEAERAhMVFh/9oACAEBAAE/IVDbuNNlruJbjHwJeaT/2gAMAwEAAgADAAAAEPs//8QAFhEBAQEAAAAAAAAAAAAAAAAAABFB/9oACAEDAQE/ENR//8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERIf/aAAgBAgEBPxBtYmlP/8QAGhABAAIDAQAAAAAAAAAAAAAAAQARIUFxwf/aAAgBAQABPxDMENFkNdVJpdXNxjwQChQ5POE//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "welcome zone volumetric slat wall showing color strategy",
              "title": "welcome zone volumetric slat wall showing color strategy",
              "src": "/workplace-xg/static/ad8abe620532aa1e6130aeb35cb51f1a/2e753/welcome-zone-color-strategy-lenticular-wall.jpg",
              "srcSet": ["/workplace-xg/static/ad8abe620532aa1e6130aeb35cb51f1a/69549/welcome-zone-color-strategy-lenticular-wall.jpg 288w", "/workplace-xg/static/ad8abe620532aa1e6130aeb35cb51f1a/473e3/welcome-zone-color-strategy-lenticular-wall.jpg 576w", "/workplace-xg/static/ad8abe620532aa1e6130aeb35cb51f1a/2e753/welcome-zone-color-strategy-lenticular-wall.jpg 1152w", "/workplace-xg/static/ad8abe620532aa1e6130aeb35cb51f1a/a052a/welcome-zone-color-strategy-lenticular-wall.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Brand expression" mdxType="TwoSections">
 <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`The IBM 8-bar logo should be considered an extension of the surrounding interior design. Materiality can be customized to best complement our finish palette. Within most Welcome zones, guests are already aware they’re inside an IBM location. With this perception in mind, the IBM identity can be more tonal in execution.`}</p>
        <p>{`Consider debossing or embossing the logo within different substrates. The size, scale and location of the logo should be identified with purpose based on the surrounding furniture and architectural elevation. In some cases, the logo can be applied to the reception desk itself if a wall condition isn’t ideal.`}</p>
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAGfY0TooJf/xAAYEAADAQEAAAAAAAAAAAAAAAABAgMRAP/aAAgBAQABBQKcqiiBtXcPAcowf//EABcRAAMBAAAAAAAAAAAAAAAAAAECEBH/2gAIAQMBAT8BC5P/xAAXEQADAQAAAAAAAAAAAAAAAAABAgMQ/9oACAECAQE/AaULnP/EABsQAAICAwEAAAAAAAAAAAAAAAERAhAAIjFx/9oACAEBAAY/AouBTrYu+k+5/8QAGhAAAwEBAQEAAAAAAAAAAAAAAAERITFhgf/aAAgBAQABPyFoJp1ChqszBFwN4ocMpVXqMb6FP//aAAwDAQACAAMAAAAQOw//xAAWEQEBAQAAAAAAAAAAAAAAAAABECH/2gAIAQMBAT8QIZP/xAAWEQADAAAAAAAAAAAAAAAAAAABEBH/2gAIAQIBAT8QCKv/xAAaEAACAwEBAAAAAAAAAAAAAAABEQAhMXFh/9oACAEBAAE/EANAElgQamImwDEJh1Bcg3eR1IwMGxyAVsNsT//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "IBM logo brand expression",
            "title": "IBM logo brand expression",
            "src": "/workplace-xg/static/db3eb375f5247c99dd9b3ca394d0f716/2e753/ibm-logo-brand-expression.jpg",
            "srcSet": ["/workplace-xg/static/db3eb375f5247c99dd9b3ca394d0f716/69549/ibm-logo-brand-expression.jpg 288w", "/workplace-xg/static/db3eb375f5247c99dd9b3ca394d0f716/473e3/ibm-logo-brand-expression.jpg 576w", "/workplace-xg/static/db3eb375f5247c99dd9b3ca394d0f716/2e753/ibm-logo-brand-expression.jpg 1152w", "/workplace-xg/static/db3eb375f5247c99dd9b3ca394d0f716/a052a/ibm-logo-brand-expression.jpg 1216w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
  </Column>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Rhythm and pattern" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`Rhythm and pattern are core components of our environmental design characteristics. A dramatic use of pattern in our Welcome zones reinforces an IBM sense of identity. Patterns may be integrated into millwork or other finishes. Complexity and detailing are variable based on the size and budget of a project.`}</p>
        <p>{`Consider different fabrication methods for pattern execution, such as dimensional elements versus die-cut designs. The application of pattern can occur in a variety of areas, such as feature walls, ceilings and screen elements. Location and design should be considered in context of the Welcome zone reception desk. Learn more about designing custom patterns using the `}<a href="https://www.ibm.com/design/language/2x-grid">{`2x Grid`}</a>{`.`}</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAEDBAX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAdCIRXGan//EABkQAAMBAQEAAAAAAAAAAAAAAAABAhIRIf/aAAgBAQABBQLMl4lNwecrDhuWf//EABYRAQEBAAAAAAAAAAAAAAAAAAABIf/aAAgBAwEBPwGtf//EABgRAAIDAAAAAAAAAAAAAAAAAAABISIx/9oACAECAQE/AVslT//EABoQAAICAwAAAAAAAAAAAAAAAAABETFBkaH/2gAIAQEABj8Cslszoshl8P/EABoQAAMAAwEAAAAAAAAAAAAAAAABETFBcbH/2gAIAQEAAT8hMuGeFAavUJDW46OrKP8A/9oADAMBAAIAAwAAABB33//EABgRAAIDAAAAAAAAAAAAAAAAAAABITFh/9oACAEDAQE/EKQJYP/EABgRAAIDAAAAAAAAAAAAAAAAAAABMUFR/9oACAECAQE/EIqDeGf/xAAcEAEBAAMAAwEAAAAAAAAAAAABEQAhMUGBocH/2gAIAQEAAT8QqYERJhEq+sHs7F2jGLro0S+GcoMItvjb3D6bIm/7n//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "welcome zone reception",
              "title": "welcome zone reception",
              "src": "/workplace-xg/static/85d5456ac89c0a95e1c5831a5316bf69/2e753/welcome-zone-reception.jpg",
              "srcSet": ["/workplace-xg/static/85d5456ac89c0a95e1c5831a5316bf69/69549/welcome-zone-reception.jpg 288w", "/workplace-xg/static/85d5456ac89c0a95e1c5831a5316bf69/473e3/welcome-zone-reception.jpg 576w", "/workplace-xg/static/85d5456ac89c0a95e1c5831a5316bf69/2e753/welcome-zone-reception.jpg 1152w", "/workplace-xg/static/85d5456ac89c0a95e1c5831a5316bf69/a052a/welcome-zone-reception.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFA//EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAd06cwqDIf/EABsQAAICAwEAAAAAAAAAAAAAAAIDAQQAEhMU/9oACAEBAAEFAnP5z6iwJ2CzW7EVFsYkZFP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAgIDAAAAAAAAAAAAAAAAAQIRECESMVH/2gAIAQEABj8CqsJ+ikpVo1xZBPtI/8QAGxABAQEAAgMAAAAAAAAAAAAAAREAITFBgbH/2gAIAQEAAT8hh81Lluoetd/C5SFkRN8YuAOAHf/aAAwDAQACAAMAAAAQw8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAdEAEBAAIBBQAAAAAAAAAAAAABEQAhYTFRcaHR/9oACAEBAAE/ECnFEt7zHtC4+8RJUVnX4Ckdrbec2j8iPsw0oIoxDP/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "black on black slat wall color strategy",
              "title": "black on black slat wall color strategy",
              "src": "/workplace-xg/static/e12d306a899bc77ffeea34c486bcd550/473e3/black-on-black-slat-wall-color-strategy.jpg",
              "srcSet": ["/workplace-xg/static/e12d306a899bc77ffeea34c486bcd550/69549/black-on-black-slat-wall-color-strategy.jpg 288w", "/workplace-xg/static/e12d306a899bc77ffeea34c486bcd550/473e3/black-on-black-slat-wall-color-strategy.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIBAwX/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIQAxAAAAHMhVHKw//EABgQAAMBAQAAAAAAAAAAAAAAAAABEQIQ/9oACAEBAAEFAqVt67T/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAXEAEAAwAAAAAAAAAAAAAAAAAAASAh/9oACAEBAAY/Amop/8QAHBAAAwABBQAAAAAAAAAAAAAAAAERMSFRcaHB/9oACAEBAAE/IcJuoOwzbeehtOPrKUY//9oADAMBAAIAAwAAABCQD//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAQACAgEFAAAAAAAAAAAAAAEAETFB8CFRYXGx/9oACAEBAAE/EBlVUi8jV/CIWgKXPXKWEaRL1iTXOBO4T//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "black on black slat wall color strategy detail",
              "title": "black on black slat wall color strategy detail",
              "src": "/workplace-xg/static/9cb8db48a2a1399ed89ddc9e7192e3e1/473e3/black-on-black-slat-wall-color-strategy-detail.jpg",
              "srcSet": ["/workplace-xg/static/9cb8db48a2a1399ed89ddc9e7192e3e1/69549/black-on-black-slat-wall-color-strategy-detail.jpg 288w", "/workplace-xg/static/9cb8db48a2a1399ed89ddc9e7192e3e1/473e3/black-on-black-slat-wall-color-strategy-detail.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAelDWUUGiv/EABsQAAIBBQAAAAAAAAAAAAAAAAACARAREhMx/9oACAEBAAEFApL0ZcjXIvP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAUEAEAAAAAAAAAAAAAAAAAAAAg/9oACAEBAAY/Al//xAAYEAEBAQEBAAAAAAAAAAAAAAABABEhMf/aAAgBAQABPyFZPEahc3cnQ8YIR9v/2gAMAwEAAgADAAAAEMTP/8QAFhEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAEDAQE/EBF//8QAFhEAAwAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EDV//8QAGhABAAMAAwAAAAAAAAAAAAAAAQARITFRYf/aAAgBAQABPxCjaPEUbRClTp1LyMvJnECA7QNn/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "perforation wood on wood slat wall",
              "title": "perforation wood on wood slat wall",
              "src": "/workplace-xg/static/5c1afcab64ca109e31901f10c0025a7c/473e3/perforation-wood-on-wood-slat-wall.jpg",
              "srcSet": ["/workplace-xg/static/5c1afcab64ca109e31901f10c0025a7c/69549/perforation-wood-on-wood-slat-wall.jpg 288w", "/workplace-xg/static/5c1afcab64ca109e31901f10c0025a7c/473e3/perforation-wood-on-wood-slat-wall.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAABAAL/2gAMAwEAAhADEAAAAe18bLMsF//EABoQAAICAwAAAAAAAAAAAAAAAAARARASIUL/2gAIAQEAAQUCk6yQt1//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAXEAEAAwAAAAAAAAAAAAAAAAAQQmGR/9oACAEBAAY/AiOln//EABwQAAICAgMAAAAAAAAAAAAAAAABESEQQWFxof/aAAgBAQABPyHpyLTUDkaUbNriTd+sf//aAAwDAQACAAMAAAAQp/8A/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPxA//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPxA//8QAHxABAQADAAEFAQAAAAAAAAAAAREAITFBYXGBkaHB/9oACAEBAAE/EBsITp9efzBCNDgWfUn7mlILsPyBhGjRya8YNMOOpPYcBhZfMz//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "perforation wood on wood slat wall detail",
              "title": "perforation wood on wood slat wall detail",
              "src": "/workplace-xg/static/e765473323f5988464cbbfce41364807/473e3/perforation-wood-on-wood-slat-wall-detail.jpg",
              "srcSet": ["/workplace-xg/static/e765473323f5988464cbbfce41364807/69549/perforation-wood-on-wood-slat-wall-detail.jpg 288w", "/workplace-xg/static/e765473323f5988464cbbfce41364807/473e3/perforation-wood-on-wood-slat-wall-detail.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Reception furniture" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`When possible, a custom reception desk is recommended for the Welcome zone. The design of an IBM reception desk can be considered an extension of our identity and developed using our principles of duality and geometry. As a place of intersection, the reception area serves as a connection point between the IBM brand and our clients. This connection can be represented in thoughtful contrast between material and form, customized to best meet the needs of a project. Learn more about `}<a parentName="p" {...{
            "href": "/workplace-xg/interior-architecture/furniture#custom-furniture"
          }}>{`custom furniture design`}</a>{`.`}</p>
        <p>{`The Welcome zone should also have comfortable lounge-type seating with side tables to accept visitors who are waiting. The furniture should align with the `}<a parentName="p" {...{
            "href": "https://ibm.ent.box.com/s/8q2s0mhsycd9zd0cjx2cj42rxsjk9uhd"
          }}>{`IBM Ancillary Furniture`}</a>{` tool.`}</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.25%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAALABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAEF/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAduqhS//xAAXEAADAQAAAAAAAAAAAAAAAAAAAUEQ/9oACAEBAAEFAirKj//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABcQAAMBAAAAAAAAAAAAAAAAAAABEAL/2gAIAQEABj8C0KO//8QAHBAAAQUAAwAAAAAAAAAAAAAAAAERITFRQWGR/9oACAEBAAE/IVXVdjwvxpVZeRtL6NC60gh//9oADAMBAAIAAwAAABC/D//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EAB4QAAICAgMBAQAAAAAAAAAAAAERACFBUTFxoWGR/9oACAEBAAE/ECgGmmtdV7AOZJFZeXDeAINuEVm/VdanJdNi/ILAybPJJn//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception desk examples",
              "title": "reception desk examples",
              "src": "/workplace-xg/static/bcc1a09f829fd4d2874c5c1231c47c81/2e753/reception-desk-examples.jpg",
              "srcSet": ["/workplace-xg/static/bcc1a09f829fd4d2874c5c1231c47c81/69549/reception-desk-examples.jpg 288w", "/workplace-xg/static/bcc1a09f829fd4d2874c5c1231c47c81/473e3/reception-desk-examples.jpg 576w", "/workplace-xg/static/bcc1a09f829fd4d2874c5c1231c47c81/2e753/reception-desk-examples.jpg 1152w", "/workplace-xg/static/bcc1a09f829fd4d2874c5c1231c47c81/a052a/reception-desk-examples.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIDBP/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHXWCpUQX//xAAYEAEAAwEAAAAAAAAAAAAAAAARAAEQEv/aAAgBAQABBQJp5wgZ/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFxAAAwEAAAAAAAAAAAAAAAAAAAEhIP/aAAgBAQAGPwKkef/EABsQAQACAgMAAAAAAAAAAAAAAAEAETFBIVFx/9oACAEBAAE/IaCXB31KJYvsxG0EuJTvM//aAAwDAQACAAMAAAAQN8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAgEBPxCH/8QAHhABAAICAgMBAAAAAAAAAAAAAQARIVExQWFxgeH/2gAIAQEAAT8QKxE41S8xqBfH5Esj1qFl3uWipsGh9nEELYrmsE//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception desk example",
              "title": "reception desk example",
              "src": "/workplace-xg/static/3920d9d28573ebb25416c3015f4f3853/473e3/reception-desk-example.jpg",
              "srcSet": ["/workplace-xg/static/3920d9d28573ebb25416c3015f4f3853/69549/reception-desk-example.jpg 288w", "/workplace-xg/static/3920d9d28573ebb25416c3015f4f3853/473e3/reception-desk-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIDBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAeqmDdI//8QAGhABAAIDAQAAAAAAAAAAAAAAAQARAhASE//aAAgBAQABBQKydGnAZ5ECj//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABQQAQAAAAAAAAAAAAAAAAAAACD/2gAIAQEABj8CX//EABoQAQEBAQADAAAAAAAAAAAAAAEAESExYXH/2gAIAQEAAT8hScXt7IdNJnXb63APBf/aAAwDAQACAAMAAAAQkA//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAcEAEAAgEFAAAAAAAAAAAAAAABABEhMUFRYfD/2gAIAQEAAT8Qw8cJ04AJYywNtMM8mGTOxP/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception desk example",
              "title": "reception desk example",
              "src": "/workplace-xg/static/876b814c95d01e2c759fef69b598a5ff/473e3/reception-desk-example-1.jpg",
              "srcSet": ["/workplace-xg/static/876b814c95d01e2c759fef69b598a5ff/69549/reception-desk-example-1.jpg 288w", "/workplace-xg/static/876b814c95d01e2c759fef69b598a5ff/473e3/reception-desk-example-1.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhADEAAAAdZViSgA/8QAGxAAAgIDAQAAAAAAAAAAAAAAAgMAAQQQEhP/2gAIAQEAAQUCe3yBOR3ohooKV1U//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAGRAAAgMBAAAAAAAAAAAAAAAAAREAEBIy/9oACAEBAAY/AmnDpCkQ5yK//8QAGxABAAIDAQEAAAAAAAAAAAAAAREhABAxUZH/2gAIAQEAAT8hYCLR3GqKcJ7oKEPHKVN91//aAAwDAQACAAMAAAAQs8//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAaEAEBAQEBAQEAAAAAAAAAAAABEQAxIWGB/9oACAEBAAE/EE7iUMS6DjXsI+XuGlytRIhRwo8bqdfuCAb/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception seating example",
              "title": "reception seating example",
              "src": "/workplace-xg/static/c9eeabe880f6aae46a2a355bf3c5130b/473e3/reception-seating-example.jpg",
              "srcSet": ["/workplace-xg/static/c9eeabe880f6aae46a2a355bf3c5130b/69549/reception-seating-example.jpg 288w", "/workplace-xg/static/c9eeabe880f6aae46a2a355bf3c5130b/473e3/reception-seating-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAIEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHqzoSlk//EABoQAAIDAQEAAAAAAAAAAAAAAAECAxESABT/2gAIAQEAAQUCebDegVG20KKTheAof//EABURAQEAAAAAAAAAAAAAAAAAABAh/9oACAEDAQE/AYf/xAAVEQEBAAAAAAAAAAAAAAAAAAAQIf/aAAgBAgEBPwGn/8QAGhAAAgIDAAAAAAAAAAAAAAAAAAECERAxMv/aAAgBAQAGPwKqORSLaNY//8QAGhABAQEAAwEAAAAAAAAAAAAAAQARIUFhgf/aAAgBAQABPyE+XfsglWFjBm9WLC3ngwL/2gAMAwEAAgADAAAAEPfv/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQARMf/aAAgBAwEBPxAccm//xAAYEQACAwAAAAAAAAAAAAAAAAAAARExYf/aAAgBAgEBPxBqdi0//8QAGhABAQEBAAMAAAAAAAAAAAAAAREAMUFRcf/aAAgBAQABPxAu2y0BpJJWNcKKfN0zxoI00uB8xIwD1v/Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "reception seating sofa example",
              "title": "reception seating sofa example",
              "src": "/workplace-xg/static/4d3eb1ab460ca9bdcbcaffd7eb3355d4/473e3/reception-seating-sofa-example.jpg",
              "srcSet": ["/workplace-xg/static/4d3eb1ab460ca9bdcbcaffd7eb3355d4/69549/reception-seating-sofa-example.jpg 288w", "/workplace-xg/static/4d3eb1ab460ca9bdcbcaffd7eb3355d4/473e3/reception-seating-sofa-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>
    <Divider mdxType="Divider" />
    <TwoSections title="Flooring and ceiling" mdxType="TwoSections">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
        <p>{`As a major point of circulation, Welcome zones should use a durable flooring material, such as polished concrete, terrazzo or stone. An accent area rug or wood detail should be used where seating is present in the waiting area.`}</p>
        <p>{`A linear ceiling system may be used to complement various applications of pattern. This expression should serve to ground our signature elements and direct guests toward the Connect zone. Light fixtures should be integrated within the ceiling system.`}</p>
  </Column>
  <TwoSectionsImages mdxType="TwoSectionsImages">
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1000px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "33.33333333333333%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAHABQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAABvpAI/8QAFhAAAwAAAAAAAAAAAAAAAAAAAhAy/9oACAEBAAEFAhpf/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAgEBPwE//8QAFBABAAAAAAAAAAAAAAAAAAAAEP/aAAgBAQAGPwJ//8QAFxAAAwEAAAAAAAAAAAAAAAAAAAEQMf/aAAgBAQABPyHIc//aAAwDAQACAAMAAAAQc+//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/ED//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/ED//xAAZEAEAAgMAAAAAAAAAAAAAAAABACEQEWH/2gAIAQEAAT8Q1C7WA1P/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "flooring examples",
              "title": "flooring examples",
              "src": "/workplace-xg/static/2ece7c491b390a828f0ec71b55b42b4b/4edc6/flooring-examples.jpg",
              "srcSet": ["/workplace-xg/static/2ece7c491b390a828f0ec71b55b42b4b/69549/flooring-examples.jpg 288w", "/workplace-xg/static/2ece7c491b390a828f0ec71b55b42b4b/473e3/flooring-examples.jpg 576w", "/workplace-xg/static/2ece7c491b390a828f0ec71b55b42b4b/4edc6/flooring-examples.jpg 1000w"],
              "sizes": "(max-width: 1000px) 100vw, 1000px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAB1rZWIGif/8QAGhABAQEAAwEAAAAAAAAAAAAAAQIAAxEhMf/aAAgBAQABBQL5nkDTXkzS9XKjv//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EAB4QAAAFBQEAAAAAAAAAAAAAAAABEBEhAjEzUXGh/9oACAEBAAY/AmPSTdMZdcRT6P/EABoQAQACAwEAAAAAAAAAAAAAAAEAIRExQVH/2gAIAQEAAT8h1OAyyq34BENcIuDTfI0CkMwtqP/aAAwDAQACAAMAAAAQSz//xAAWEQEBAQAAAAAAAAAAAAAAAAAAIQH/2gAIAQMBAT8Q2K//xAAVEQEBAAAAAAAAAAAAAAAAAAAQMf/aAAgBAgEBPxCn/8QAHhABAAMAAQUBAAAAAAAAAAAAAQARIUExUZGx4fD/2gAIAQEAAT8QFaCoDonHqYq2/m5YEqVrfyBhq0qAziUm1UEjXeqhqHK1Bvif/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "IBM lobby",
              "title": "IBM lobby",
              "src": "/workplace-xg/static/ab8ef16cac67a051d7122c22fe36e851/2e753/ibm-lobby.jpg",
              "srcSet": ["/workplace-xg/static/ab8ef16cac67a051d7122c22fe36e851/69549/ibm-lobby.jpg 288w", "/workplace-xg/static/ab8ef16cac67a051d7122c22fe36e851/473e3/ibm-lobby.jpg 576w", "/workplace-xg/static/ab8ef16cac67a051d7122c22fe36e851/2e753/ibm-lobby.jpg 1152w", "/workplace-xg/static/ab8ef16cac67a051d7122c22fe36e851/a052a/ibm-lobby.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAG9TdljLA//xAAZEAADAAMAAAAAAAAAAAAAAAAAAQIQEiL/2gAIAQEAAQUCGsU5hbQcH//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABgQAAMBAQAAAAAAAAAAAAAAAAACMRAR/9oACAEBAAY/At68IRT/xAAbEAADAAIDAAAAAAAAAAAAAAAAAREhMVGR8f/aAAgBAQABPyFrgsRoqBqpgvrs2X3H/9oADAMBAAIAAwAAABCwz//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxBsf//EAB4QAQACAgEFAAAAAAAAAAAAAAEAIRFBgWFxkaHR/9oACAEBAAE/EBbeem5hNRQgpxBzkNl8doHyCNjc9Rdy+L4n/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "felt ceiling example",
              "title": "felt ceiling example",
              "src": "/workplace-xg/static/cebd743f1e1a3fb0ed51a6977122538e/473e3/felt-ceiling-example.jpg",
              "srcSet": ["/workplace-xg/static/cebd743f1e1a3fb0ed51a6977122538e/69549/felt-ceiling-example.jpg 288w", "/workplace-xg/static/cebd743f1e1a3fb0ed51a6977122538e/473e3/felt-ceiling-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={6} colMd={4} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "576px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAMBAgT/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAv/aAAwDAQACEAMQAAABRGmsWseH/8QAGBAAAwEBAAAAAAAAAAAAAAAAARETAAL/2gAIAQEAAQUC6aJLOmVMue//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQMBAT8BrX//xAAWEQEBAQAAAAAAAAAAAAAAAAAAARH/2gAIAQIBAT8BjH//xAAaEAACAgMAAAAAAAAAAAAAAAAAAREhAhBx/9oACAEBAAY/AnBhe+KC2f/EABoQAQEBAAMBAAAAAAAAAAAAAAERACExQWH/2gAIAQEAAT8hhY05MkhRBdV8MWdXEkmHPuvzf//aAAwDAQACAAMAAAAQE+//xAAXEQADAQAAAAAAAAAAAAAAAAAAAREh/9oACAEDAQE/EHrxkn//xAAXEQADAQAAAAAAAAAAAAAAAAAAASER/9oACAECAQE/EFlRs//EAB0QAQACAgMBAQAAAAAAAAAAAAEAIRExUWGxkfH/2gAIAQEAAT8QeAVlyGz55Aalnq18iWVDYLMMbNXpgzCwbd/kQs8jTE//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "coffered wood ceiling example",
              "title": "coffered wood ceiling example",
              "src": "/workplace-xg/static/e0cd72c2274899e43d0cab80ae08662a/473e3/coffered-wood-ceiling-example.jpg",
              "srcSet": ["/workplace-xg/static/e0cd72c2274899e43d0cab80ae08662a/69549/coffered-wood-ceiling-example.jpg 288w", "/workplace-xg/static/e0cd72c2274899e43d0cab80ae08662a/473e3/coffered-wood-ceiling-example.jpg 576w"],
              "sizes": "(max-width: 576px) 100vw, 576px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  <Column colLg={12} colMd={8} colSm={4} mdxType="Column">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEAv/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHLJnzTCwT/xAAaEAEBAQADAQAAAAAAAAAAAAABAAIDERMh/9oACAEBAAEFAvPMDZ4iz3Cl8L//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAbEAACAQUAAAAAAAAAAAAAAAAAASECESIxUf/aAAgBAQAGPwLFnSTYqXeWQf/EABoQAQADAQEBAAAAAAAAAAAAAAEAESFBUWH/2gAIAQEAAT8hGMn4sUUtD3Yst7fIbACZI7NJONqn/9oADAMBAAIAAwAAABAoH//EABYRAAMAAAAAAAAAAAAAAAAAAAABEf/aAAgBAwEBPxCsrP/EABYRAAMAAAAAAAAAAAAAAAAAAAABEf/aAAgBAgEBPxCIiP/EAB4QAQACAgEFAAAAAAAAAAAAAAEAESFBcTFRYYGh/9oACAEBAAE/ELch4LG4MLHF5i/qTDwHaMvJdiX7gm6AgL4uI941GsfJ/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "wood slat ceiling example",
              "title": "wood slat ceiling example",
              "src": "/workplace-xg/static/6aae7bfe85be66800d49aa4b83741b7b/2e753/wood-slat-ceiling-example.jpg",
              "srcSet": ["/workplace-xg/static/6aae7bfe85be66800d49aa4b83741b7b/69549/wood-slat-ceiling-example.jpg 288w", "/workplace-xg/static/6aae7bfe85be66800d49aa4b83741b7b/473e3/wood-slat-ceiling-example.jpg 576w", "/workplace-xg/static/6aae7bfe85be66800d49aa4b83741b7b/2e753/wood-slat-ceiling-example.jpg 1152w", "/workplace-xg/static/6aae7bfe85be66800d49aa4b83741b7b/a052a/wood-slat-ceiling-example.jpg 1216w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
  </Column>
  </TwoSectionsImages>
    </TwoSections>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      